import { render, staticRenderFns } from "./DeliveryDataDetail.vue?vue&type=template&id=da840f94&scoped=true&"
import script from "./DeliveryDataDetail.vue?vue&type=script&lang=ts&"
export * from "./DeliveryDataDetail.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryDataDetail.vue?vue&type=style&index=0&id=da840f94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da840f94",
  null
  
)

export default component.exports